module.exports = __webpack_public_path__ + "img/HQ-OA-360V03NGU_ALL.5358a747.jpg";